module.exports = __webpack_public_path__ + "img/back.b8f93823.svg";